@if (!this.loading && !colectivo) {
  <app-breadcrumb
    listado="/main/colectivos/colectivos"
    etiquetaListado="Colectivos"
    [titulo]="colectivo?.identificacion"
  ></app-breadcrumb>
  <app-empty-state
    icon="directions_bus"
    message="No se encontró el colectivo"
  ></app-empty-state>
} @else if (!this.loading && colectivo) {
  <app-breadcrumb
    listado="/main/colectivos/colectivos"
    etiquetaListado="Colectivos"
    [titulo]="colectivo?.identificacion"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>directions_bus</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ colectivo.identificacion }}</h1>
      @if (colectivo.vehiculo?.patente) {
        <span class="encabezado-nombre encabezado-patente">
          {{ helper.formatPatente(colectivo.vehiculo.patente) }}
        </span>
      }
      <div class="encabezado-chips">
        @if (colectivo.grupo?.nombre) {
          <span class="chip">
            <mat-icon>workspaces</mat-icon>
            Línea {{ colectivo.grupo.nombre }}
          </span>
        }
        @if (colectivo.cliente?.nombre) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ colectivo.cliente.nombre }}
          </span>
        }
        @if (colectivo.vehiculo?.estado; as estado) {
          <span [class]="'chip estado-' + claseEstado(estado)">
            {{ estado }}
          </span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar colectivo"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <!-- Info -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-colectivo-info
          [colectivo]="colectivo"
        ></app-detalles-colectivo-info>
      </ng-template>
    </mat-tab>
    <!-- Ver Viajes/Paradas -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">route</mat-icon>
        <span>Viajes y Paradas</span>
      </ng-template>
      <ng-template matTabContent>
        <!-- Llena el alto de la pestaña: el mapa toma el alto del contenedor
             (antes lo daba cardContentPestaña, con un alto fijo). -->
        <app-viajes-paradas
          style="display: block; height: 100%"
          [vehiculo]="colectivo"
        ></app-viajes-paradas>
      </ng-template>
    </mat-tab>
    <!-- Historial de Eventos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">report</mat-icon>
        <span>Historial Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-genericos-historico
          [id]="colectivo._id"
        ></app-eventos-genericos-historico>
      </ng-template>
    </mat-tab>

    <!-- Codigos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">integration_instructions</mat-icon>
        <span>Códigos Eventos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-configs-eventos
          [dispositivo]="colectivo"
          tipo="Activo"
        ></app-listado-configs-eventos>
      </ng-template>
    </mat-tab>
    <!--Eventos Personalizados -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">rule</mat-icon>
        <span>Eventos Personalizados</span>
      </ng-template>
      <ng-template matTabContent>
        @if (params) {
          <app-listado-config-evento-usuario
            [params]="params"
          ></app-listado-config-evento-usuario>
        }
      </ng-template>
    </mat-tab>
    <!-- Notas -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">note</mat-icon>
        <span>Notas</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="colectivo._id"
          [idCliente]="colectivo.idCliente"
          tipo="Nota"
          tipoDispositivo="Colectivo"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>
    <!-- Contactos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">contacts</mat-icon>
        <span>Contactos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-notas
          [idAsignado]="colectivo._id"
          [idCliente]="colectivo.idCliente"
          tipo="Contacto"
          tipoDispositivo="Colectivo"
        ></app-listado-notas>
      </ng-template>
    </mat-tab>
    <!-- Documentos -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">folder</mat-icon>
        <span>Documentos</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-documentos
          [idEntidad]="colectivo._id"
          [idCliente]="colectivo.idCliente"
          tipoEntidad="Colectivo"
        ></app-listado-documentos>
      </ng-template>
    </mat-tab>
    @if (helper.esNivel0()) {
      <!-- Trackeos -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">gps_fixed</mat-icon>
          <span>Trackeos</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-trackeos [vehiculo]="colectivo"></app-listado-trackeos>
        </ng-template>
      </mat-tab>
      <!-- Log Trackeos-->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">terminal</mat-icon>
          <span>Log Trackeos</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-logs-trackeos
            [vehiculo]="colectivo"
          ></app-listado-logs-trackeos>
        </ng-template>
      </mat-tab>
    }
    <!-- Servicio Técnico -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">build</mat-icon>
        <span>Servicio Técnico</span>
      </ng-template>
      <ng-template matTabContent>
        <app-eventos-tecnicos-genericos
          [id]="colectivo._id"
        ></app-eventos-tecnicos-genericos>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="directions_bus"
    listado="/main/colectivos/colectivos"
    etiquetaListado="Colectivos"
    [pestanas]="11"
  ></app-detalle-esqueleto>
}
